export default __webpack_public_path__ + "a77c7df03e685ae4c57bf81075733640.woff2";